import * as Sentry from "@sentry/react";
import { IS_DEBUG } from "../../config";

export default function logError(errorMessage, error, additionalData = {}, logToSentry = true) {

    if (logToSentry) {
        // Capture the error in Sentry
        Sentry.withScope(scope => {
            // Add the additional data to the scope
            scope.setContext('Additional Data', additionalData);
            
            // Add a breadcrumb for additional context
            scope.addBreadcrumb({
                message: errorMessage
            });

            // Capture the original error directly to preserve the stack trace and original message
            Sentry.captureException(error);
        });
    }

    // Log the error to the console if debugging is enabled
    if (IS_DEBUG) {
        console.error(errorMessage, error, additionalData);
    }
}

/** 
 * Normalise a returned error to standard format and ensure it returns with .message
 *
 * @param {unknown} origError
 * @returns {Error}
 */
export function toError(origError) {
  if (origError == null) return new Error('Unknown error');

  // Axios: unwrap response.data if present
  if (typeof origError === 'object' && origError && 'response' in origError) {
    const errorResponse = (origError).response;
    if (errorResponse?.data) return toError(errorResponse.data);
    if (typeof origError.message === 'string') return new Error(origError.message);
  }

  if (origError instanceof Error) return origError; // Already an Error type

  // API payload: should be under errorResponse  - not an Error type
  if (typeof origError === 'object' && origError) {
    const payload = origError.errorResponse ?? origError;

    const msg = (typeof payload.message === 'string' && payload.message.trim()) || 'Unknown error';
    const newError = new Error(msg);

    if (payload.code !== undefined) { newError.code = payload.code; }
    
    return newError;
  }

  if (typeof origError === 'string') return new Error(origError);

  return new Error('Unknown error');
}